import React from 'react'
import { PhoneNumberInput } from 'src/graphql/generated/graphql'
import { useActions } from 'src/hooks'
import { getFormattedNumber } from 'src/onboarding/components/PhoneNumberVerification'
import { useMarketingContent } from 'src/react_query'
import {
  Button,
  Flex,
  Icon,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'

const UnverifiedAccountFound = (props: { phoneNumber: PhoneNumberInput }) => {
  const { phoneNumber } = props

  const { data: marketingContent } = useMarketingContent({ suspense: true })

  const formattedNumber = getFormattedNumber(
    phoneNumber.countryIsoCode,
    phoneNumber.nationalNumber,
  )

  const actions = useActions()

  const title = marketingContent?.unverifiedAccountsFoundCopy.title
  const description = marketingContent?.unverifiedAccountsFoundCopy.content

  const content = (
    <>
      <Text type="subtitle" alignment="center">
        {title}
      </Text>
      <Text type="caption" weight="semiBold" alignment="center">
        {formattedNumber}
      </Text>
      <Text type="caption" alignment="left">
        {description}
      </Text>
    </>
  )

  const buttons = (
    <>
      <Flex flexDirection={'row'} justifyContent="space-between">
        <Button
          title={'Go to Log In'}
          onClick={() => {
            actions.openAccount()
          }}
          size="small"
          outlined={true}
          type="danger"
          hover={true}
        />
      </Flex>
      <Spacer space="x3" />
      <Text type="caption" alignment="left">
        For further assistance, contact the Customer Success team at
        <b> (801) 463-3800 </b>
        to resolve this issue.
      </Text>
    </>
  )

  return (
    <div>
      <Spacer space="x4" />
      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >
        <Icon name="exclamation" size="xLarge" primaryColor="danger" />
        {content}
      </Flex>
      <Spacer space="x2" />
      <Flex justifyContent="center" flexDirection="column" alignItems="center">
        {buttons}
      </Flex>
    </div>
  )
}

export default UnverifiedAccountFound
